import { PlanModelInfo, planTypes } from '@/common/constants';
import {} from '@/common/constants';
import { enableCAICPlanRebranding } from '@/plans/ZOOM_CUSTOM_AI_COMPANION/utils.js';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';

const aiCompanionCategory = {
  [planTypes.ZM_AI_COMPANION]: {
    typeNameKey: enableCAICPlanRebranding
      ? 'billing.zoom_ai_companion.rebranding_title'
      : 'billing.zoom_ai_companion.title',
    planNameKey: enableCAICPlanRebranding
      ? 'billing.zoom_ai_companion.rebranding_title'
      : 'billing.zoom_ai_companion.title',
  },
};

export default (planMapJSON = {}) => {
  const result = Object.keys(aiCompanionCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.ZM_AI_COMPANION).map((item) => ({
        ...item,
        ...aiCompanionCategory[key],
        unit: planUnitMap.user,
        planModel: PlanModelInfo.license,
        min: 1
      })),
      ...pre,
    ];
  }, []);
  return result;
};
